<template>
  <div v-click-outside="close" @mouseover="onMouseOver" @mouseout="onMouseOut">
    <div class="lang--wrapper no-translate" :class="langWrapperClasses" @click="toggleLanguages">
      <div class="selected-lang-holder">
        <div v-if="selected.value" class="lang-selected uppercase" :style="titleStyles">
          {{ selected.value }}
        </div>
      </div>
      <div :class="arrowIconClasses" />
    </div>
    <div v-if="open" :class="langContentClasses">
      <div v-for="(lang, index) in langs" :key="index">
        <div :class="langItemClasses" class="uppercase no-translate" @click="changeLanguage(lang)">
          {{ lang.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: 'LangSelector',
  directives: {
    ClickOutside,
  },
  props: {
    white: { type: Boolean },
    autoClose: { type: Boolean },
    theme: { type: String, default: 'light' }, // VALID types are 'light' or 'dark'
  },
  data() {
    return {
      langs: [
        { id: 'en',
          value: 'English',
        },
        { id: 'fr',
          value: 'French',
        },
        { id: 'it',
          value: 'Italian',
        },
        { id: 'de',
          value: 'German',
        },
      ],
      selected: { id: 'en' },
      open: false,
      timedClose: null,
    };
  },
  computed: {
    currentLanguage() {
      return this.$store.getters['common/currentLanguage'];
    },
    titleStyles() {
      return {
        color: this.white ? '#ffffff' : '#1F212F',
        // border: this.white ? '1px solid #ffffff' : '1px solid #050817',
        // backgroundColor: this.white ? '#ffffff':'#1F212F',
      };
    },
    langWrapperClasses() {
      return {
        'lang--wrapper--light': this.theme === 'light',
        'lang--wrapper--dark': this.theme === 'dark',
      };
    },
    arrowIconClasses() {
      return {
        'arrow-icon': true,
        'arrow-icon--light': this.theme === 'light',
        'arrow-icon--dark': this.theme === 'dark' || this.white,
        'arrow-icon--open': this.open,
      };
    },
    langContentClasses() {
      return {
        'lang-content': true,
        'lang-content--light': this.theme === 'light',
        'lang-content--dark': this.theme === 'dark',
      };
    },
    langItemClasses() {
      return {
        'lang-item': true,
        'lang-item--light': this.theme === 'light',
        'lang-item--dark': this.theme === 'dark',
      };
    },
  },
  watch: {
    currentLanguage: {
      handler(n, o) {
        this.selected = this.langs.find((lang) => lang.id === n);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // this.setLanguageFromLocalize();
  },
  methods: {
    setLanguageFromLocalize() {
      const langID = Localize.getLanguage() || this.currentLanguage;
      this.selected = this.langs.find((lang) => lang.id === langID);
    },
    toggleLanguages() {
      this.open = !this.open;
    },
    changeLanguage(language) {
      Localize.setLanguage(language.id);
      this.selected = language;
      this.open = false;
      this.$store.commit('common/setCurrentLanguage', language.id);

      // GA and Exponea tracking
      window.dataLayer = window.dataLayer || [];
      const objPush = { event: 'change_language', language_id: language.id };
      window.dataLayer.push(objPush);
    },
    close() {
      if (this.open) {
        this.open = false;
      }
    },

    onMouseOver() {
      if (this.autoClose) {
        clearTimeout(this.timedClose);
      }
    },
    onMouseOut() {
      if (this.autoClose) {
        this.timedClose = setTimeout(() => this.close(), 200);
      }
    },

  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/settings/config.scss';

 .lang--wrapper {
    font-size: 12px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 50px;
    height: 32px;
    padding: 5px 12px;

    &--light {
      // border: $darkBlack;
      // background-color: $darkBlue;
    }

    &--dark {
      border: $darkBlack;
      background-color: $darkBlue;
    }
  }

  .arrow-icon {
    margin: 2px 0 0 10px;

    &--light{
      background-image: svg-load('icons/curved-chevron-down-dark.svg');
      background-size: contain;
      height: 10px;
      width: 13px;
    }

    &--dark{
    background-image: svg-load('icons/curved-chevron-down-light.svg');
      background-size: contain;
      height: 10px;
      width: 13px;
    }

    &--open{
      margin: 3px 0px 0px 10px;
      transform: translateY(-2px) rotate(180deg);
    }
  }

  .lang-content {
    font-size: 12px;
    position: absolute;
    z-index: 40; // needed to bypass open nav
    margin: 5px 0 0 12px;

    &--light{
      background-color: $stoneWhite;
      color: $darkBlack;
      border:1px solid $stoneLight;
    }

    &--dark{
      background-color: $darkBlue;
      border: 1px solid $darkBlack;
      color: $white;
    }
  }

  .lang-item{
    padding:5px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &--light{
      &:hover{
        background-color: $solitude;
      }
    }

    &--dark{
      &:hover{
        background-color: $cornflower;
      }
    }
  }
</style>
